import { VisibilityOff, Visibility } from '@mui/icons-material';
import type { TextFieldProps } from '@mui/material';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import React from 'react';
import { useToggle } from '../../../../hooks/use-toggle';

export const PasswordInput = React.forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const [showPassword, toggleShowPassword] = useToggle(false);
  const { label = 'Password' } = props;

  return (
    <TextField
      ref={ref}
      label={label}
      variant="filled"
      fullWidth
      size="medium"
      type={showPassword ? 'text' : 'password'}
      {...props}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => toggleShowPassword()}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }
      }} />
  );
});
